import {
  IClipControlProps,
  RegionData,
} from '@/pages/editor/component/LiveWindow/component/ClipControl/ClipControl'
import { deepCopy } from '@/utils'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

export interface IPrepareTransition {
  clipIndex: number
  leftPostion: number
  trackIndex: number
}
const initialState: {
  clipIndex: number
  trackIndex: number
  resizeModalData: any
  sliderMenuKey: string
  editPanel: string
  prepareTransition: IPrepareTransition | null
  showReplaceClipDialog: boolean
  showReplacClipModal: boolean
  showResizeModal: boolean
  pieceSelectedResource: null | IFileResource
  currentMenuItem: string
  currentSubMenuItem: string
  currentCropRegion: null | RegionData
  clipControlProps: null | IClipControlProps
  subtitlesPageStatus: string,
  subtitlePanelKey: number,
  reloadFromIndexKey: number,
  templateReplaceClipData: any,
  syncTemplateMedia: Boolean,
  isNoCrop: boolean,
  accountFeatureList:any
} = {
  clipIndex: -1,
  trackIndex: -1,
  resizeModalData: null,
  editPanel: '',
  sliderMenuKey: 'streams',
  prepareTransition: null,
  showReplaceClipDialog: false,
  showReplacClipModal: false,
  showResizeModal: false,
  pieceSelectedResource: null,
  currentMenuItem: '',
  currentSubMenuItem: '',
  currentCropRegion: null,
  clipControlProps: null,
  subtitlesPageStatus: 'preview',
  subtitlePanelKey: 0,
  reloadFromIndexKey: 0,
  templateReplaceClipData: null,
  syncTemplateMedia: false,
  isNoCrop: false,
  accountFeatureList:[],
}

export const editorSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    updateIsNoCrop(state, { payload }: PayloadAction<boolean>) {
      state.isNoCrop = payload;
    },
    updateAccountFeatureList(state, {payload}:any){
      state.accountFeatureList = payload;
      if(payload.length>0){
        payload.forEach((element:any) => {
          if(element.feature === 'shift_on_drag'){
            state.isNoCrop = true;
          }
        });
      }
    },
    updatereloadFromIndexKey(state) {
      state.reloadFromIndexKey++;
    },
    updateSubtitleKey(state) {
      state.subtitlePanelKey += 1
    },
    updateEditClipInfo(
      state,
      {
        payload,
      }: PayloadAction<{
        trackIndex: number
        clipIndex: number
      }>,
    ) {
      state.clipIndex = payload.clipIndex
      state.trackIndex = payload.trackIndex
    },
    updateSliderMenuKey(state, { payload }: PayloadAction<string>) {
      state.sliderMenuKey = payload
    },
    updateEditPanel(state, { payload }: PayloadAction<any>) {
      state.editPanel = payload
    },
    updatePrepareTransition(
      state,
      { payload }: PayloadAction<IPrepareTransition | null>,
    ) {
      state.prepareTransition = payload
    },
    isShowReplaceClipDialog(state, { payload }: PayloadAction<boolean>) {
      state.showReplaceClipDialog = payload
    },
    isShowResizeClipModal(state, { payload }: PayloadAction<boolean>) {
      state.showResizeModal = payload
    },
    updateResizeModalData(state, { payload }) {
      state.resizeModalData = payload
    },
    isShowReplaceClipModal(state, { payload }: PayloadAction<boolean>) {
      state.showReplacClipModal = payload
    },
    updatePieceSelectedResource(
      state,
      { payload }: PayloadAction<null | IFileResource>,
    ) {
      state.pieceSelectedResource = payload
    },
    updateCurrentMenuItem(state, { payload }: PayloadAction<string>) {
      state.currentMenuItem = payload
    },
    updateCurrentSubMenuItem(state, { payload }: PayloadAction<string>) {
      state.currentSubMenuItem = payload
    },
    updateCurrentCropRegion(
      state,
      { payload }: PayloadAction<null | RegionData>,
    ) {
      state.currentCropRegion = payload
    },
    updateClipControlProps(
      state,
      { payload }: PayloadAction<null | IClipControlProps>,
    ) {
      state.clipControlProps = deepCopy(payload)
    },
    updateSubtitlesPageStatus(state, { payload }: PayloadAction<string>) {
      state.subtitlesPageStatus = payload
    },
    updateTemplateReplaceClipData(state, { payload }) {
      state.templateReplaceClipData = payload
    },
    updateSyncTemplateMedia(state, { payload }: PayloadAction<boolean>) {
      state.syncTemplateMedia = payload
    },
  },
})

export const editorActions = { ...editorSlice.actions }

export default editorSlice.reducer
